import validate from "/builds/WeArePublic/wap-app/node_modules/.pnpm/nuxt@3.21.11_@oxc-project+types@0.153.0_@types+node@22.20.5_@vue+compiler-sfc@3.5.13_ca_4dda6e840978e766d0ce94b2ef57e7b8/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45event_45date_45global from "/builds/WeArePublic/wap-app/middleware/01.event-date.global.ts";
import charge_45bee_45transaction_45redirect_45global from "/builds/WeArePublic/wap-app/middleware/ChargeBeeTransactionRedirect.global.js";
import manifest_45route_45rule from "/builds/WeArePublic/wap-app/node_modules/.pnpm/nuxt@3.21.11_@oxc-project+types@0.153.0_@types+node@22.20.5_@vue+compiler-sfc@3.5.13_ca_4dda6e840978e766d0ce94b2ef57e7b8/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  _01_45event_45date_45global,
  charge_45bee_45transaction_45redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/builds/WeArePublic/wap-app/middleware/auth.ts")
}